class ImagesProjet {

    constructor(){
        this.listeImages = jQuery('#liste_images_projet');
        this.buttonAction = document.querySelector('#afficher_plus_photos');
        this.nombreImagesTotal = this.listeImages.find('a').length;
        this._init();
    }

    _init(){
        this.nombreImages = 8;
        this.numeroClick = 0;
        
        if(this.buttonAction)
        {
            document.addEventListener('DOMContentLoaded', (event) => {
                this.buttonAction.addEventListener('click', 
                    this._affichePhotos.bind(this),
                    false
                );
            });
        }
    }
    
    _affichePhotos(){
       this.numeroClick = parseInt(this.numeroClick) + parseInt(1);
       
       //Affichage des nouvelles photos
       var numImageDebut = (parseInt(this.numeroClick) * parseInt(this.nombreImages)) + parseInt(1);
       var numImageFin = parseInt(numImageDebut) + parseInt(this.nombreImages) - parseInt(1);       
       for(var numBoucle = numImageDebut; numBoucle <= numImageFin; numBoucle++)
       {
           this.listeImages.find('.photo_'+numBoucle).css('display','block');
       }
       
       //Supprime le boutons si toutes les photos sont affichées
       if(numImageFin >= this.nombreImagesTotal)
       {
           this.buttonAction.remove();
       }
       
       return false;
    }
}

export let imagesProjet = new ImagesProjet();